// Same ECharts version and canvas renderer; retain the features used on Minto.day.
import {init, getInstanceByDom, graphic, use} from './build-tools/node_modules/echarts/core.js';
import {LineChart, BarChart, PieChart} from './build-tools/node_modules/echarts/charts.js';
import {GridComponent, TooltipComponent, LegendComponent, DataZoomComponent} from './build-tools/node_modules/echarts/components.js';
import {LabelLayout} from './build-tools/node_modules/echarts/features.js';
import {CanvasRenderer} from './build-tools/node_modules/echarts/renderers.js';
use([LineChart, BarChart, PieChart, GridComponent, TooltipComponent, LegendComponent, DataZoomComponent, LabelLayout, CanvasRenderer]);
window.echarts = {init, getInstanceByDom, graphic: {LinearGradient: graphic.LinearGradient}};
